import _ from 'lodash';
import Immutable from 'immutable';

import connect from 'components/lib/connect';
import Conversation from 'models/conversation';
import ConversationHeader from './conversation_header';
import SwitchCurrentConversation from 'actions/customer/switch_current_conversation';

let topics = Immutable.List();
let topicsLong = Immutable.List();

function mapStateToProps(context, props) {
  let { conversationId, onSlaClick } = props;
  let conversation = context.getProvider('conversations').findBy({ id: conversationId });

  if (!conversation) {
    return {};
  }

  let lastItemTimestamp = _.max(
    context
      .getProvider('conversationHistory')
      .findAll({ filter: { conversationId }, select: ['timestamp'] })
      .map(i => i.timestamp)
  );

  let assignedAgent =
    conversation.assignee && conversation.assignee.agentId
      ? context.getProvider('agents').findBy({ id: conversation.assignee.agentId })
      : undefined;
  const topic = context.getProvider('topics').findBy({ id: conversation.topicId });
  updateTopics(context, conversation.topicIds);

  return {
    ...props,
    assignedAgent,
    conversation,
    isActive: conversation.status !== Conversation.Status.CLOSED,
    lastItemTimestamp,
    topic,
    topics,
    topicsLong,
    onSlaClick,
  };
}

function updateTopics(context, topicIds) {
  let newTopics = _.map(topicIds, id => {
    let topic = context.getProvider('topics').findBy({ id });
    return topic ? { name: topic.name, longName: topic.getNameWithAncestry() } : null;
  });

  _.forEach(newTopics, (newTopic, index) => {
    topics = topics.update(index, () => (newTopic ? newTopic.name : null));
    topicsLong = topicsLong.update(index, () => (newTopic ? newTopic.longName : null));
  });
  let sizeDiff = topics.size - newTopics.length;
  if (sizeDiff > 0) {
    _.times(sizeDiff, function() {
      topics = topics.pop();
      topicsLong = topicsLong.pop();
    });
  }
}

function mapExecuteToProps(executeAction) {
  return {
    onSlaClick: (conversationId, conversationItemId) =>
      executeAction(SwitchCurrentConversation, {
        conversationId,
        conversationItemId,
      }),
  };
}

export default connect(mapStateToProps, mapExecuteToProps)(ConversationHeader);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_header_container.jsx